import { on } from 'delegated-events';

const wcbtMedia = () => {
	const { __ } = wp.i18n;
	const mediaElNodes = document.querySelectorAll( '.wcbt-image-info' );
	if ( ! mediaElNodes ) {
		return;
	}

	on( 'click', '.wcbt-image-info .wcbt-image-add,.wcbt-gallery-add', function( event ) {
		event.preventDefault();
		const mediaElNode = this.closest( '.wcbt-image-info' );
		const multiple = mediaElNode.classList.contains( 'multiple' );

		const wcbtUploader = wp.media( {
			title: __( 'Select Images', 'wcbt' ), button: {
				text: __( 'Use these images', 'wcbt' ),
			}, multiple, library: {
				type: 'image',
			},
		} );

		wcbtUploader.on( 'select', function() {
			const selection = wcbtUploader.state().get( 'selection' );
			if ( multiple === true ) {
				let attachments = selection.filter( function( item ) {
					return item.toJSON().type === 'image';
				} ).map( function( item ) {
					return item.toJSON();
				} );
				attachments = attachments.filter( ( item ) => {
					return validateFile( item, mediaElNode );
				} );
				let attachmentIds = attachments.map( function( item ) {
					return item.id;
				} );

				const number = mediaElNode.querySelector( 'input[type="hidden"]' ).getAttribute( 'data-number' );
				attachmentIds = attachmentIds.slice( 0, number );
				mediaElNode.querySelector( 'input' ).value = attachmentIds.join();

				//Gallery preview
				let galleryPreviewHtml = '';
				for ( let i = 0; i < attachmentIds.length; i++ ) {
					let src = '';
					let dataId = '';
					if ( !! attachmentIds[ i ] ) {
						dataId = attachmentIds[ i ];
						if ( !! attachments[ i ].sizes.thumbnail ) {
							src = attachments[ i ].sizes.thumbnail.url;
						} else {
							src = attachments[ i ].url;
						}
					}
					galleryPreviewHtml += `<div class="wcbt-gallery-preview" data-id="${ dataId }">
						<div class="wcbt-gallery-centered"><img src="${ src }" alt="#">
						<span class="wcbt-gallery-remove dashicons dashicons dashicons-no-alt"></span>
						</div></div>`;
				}

				if ( !! galleryPreviewHtml ) {
					mediaElNode.querySelectorAll( '.wcbt-gallery-preview' ).forEach( ( e ) => e.remove() );
					mediaElNode.querySelector( '.wcbt-gallery-add' ).insertAdjacentHTML( 'beforebegin', galleryPreviewHtml );
				}
			} else {
				const attachment = selection.first().toJSON();
				if ( validateFile( attachment, mediaElNode ) ) {
					mediaElNode.querySelector( 'input[type=text]' ).value = attachment.url;
					mediaElNode.querySelector( 'input[type=hidden]' ).value = attachment.id;
					mediaElNode.querySelector( '.wcbt-image-preview img' ).style.display = 'block';
					mediaElNode.querySelector( '.wcbt-image-preview img' ).src = attachment.url;
				} else {
					mediaElNode.querySelector( 'input[type=text]' ).value = '';
					mediaElNode.querySelector( 'input[type=hidden]' ).value = '';
					mediaElNode.querySelector( '.wcbt-image-preview img' ).style.display = 'none';
				}
			}
		} );
		wcbtUploader.on( 'open', function() {
			const selection = wcbtUploader.state().get( 'selection' );
			if ( multiple === true ) {
				let attachmentIds = mediaElNode.querySelector( 'input' ).value;

				if ( attachmentIds.length > 0 ) {
					attachmentIds = attachmentIds.split( ',' );
					attachmentIds.forEach( function( id ) {
						const attachment = wp.media.attachment( id );
						attachment.fetch();
						selection.add( attachment ? [ attachment ] : [] );
					} );
				}
			} else {
				const id = mediaElNode.querySelector( 'input[type=hidden]' ).value;
				const attachment = wp.media.attachment( id );
				attachment.fetch();
				selection.add( attachment ? [ attachment ] : [] );
			}
		} );

		wcbtUploader.open();
	} );

	//Remove image
	for ( let i = 0; i < mediaElNodes.length; i++ ) {
		const mediaElNode = mediaElNodes[ i ];
		const removeButtonNode = mediaElNode.querySelector( 'button.wcbt-image-remove' );
		if ( ! removeButtonNode ) {
			return;
		}
		removeButtonNode.addEventListener( 'click', function() {
			mediaElNode.querySelector( 'input[type=text]' ).value = '';
			mediaElNode.querySelector( 'input[type=hidden]' ).value = '';
			mediaElNode.querySelector( '.wcbt-image-preview img' ).style.display = 'none';
		} );
	}
};

const validateFile = ( item, mediaElNode ) => {
	const maxFileSize = mediaElNode.getAttribute( 'data-max-file-size' );
	const itemFileSize = ( item.filesizeInBytes ) / 1024;

	if ( maxFileSize && maxFileSize < itemFileSize ) {
		return false;
	}
	const maxWidth = mediaElNode.getAttribute( 'data-max-width' );
	const itemWidth = item.width;

	if ( maxWidth && maxWidth < itemWidth ) {
		return false;
	}
	const maxHeight = mediaElNode.getAttribute( 'data-max-height' );
	const itemHeight = item.height;

	if ( maxHeight && maxHeight < itemHeight ) {
		return false;
	}

	return true;
};

export default wcbtMedia;
